import iconBack from "../../assets/imageLoginPage/backIcon.png";
import "./styles.scss";
import React from "react";
import TextField from "../../components/text-field";
import Alert from "@mui/material/Alert";
import { useEffect, useState } from "react";
import PhotoProduct from "../../components/photo-product";
import Button from "../../components/new-button";
import { useDispatch, useSelector } from "react-redux";
import { createNewProducts, getCategories } from "../../redux/products/action";
import SelectTypeOption from "../../components/select-type-option";
import { Box, Modal } from "@mui/material";
import MultiSelect from "../../components/multi-select";
import { serialize } from 'object-to-formdata';

const NUMBER_REGEXP = new RegExp(/^\d+$/);

const validateNumString = (value) => {
  if (typeof value === 'string' && value.length !== 0) {
    return !NUMBER_REGEXP.test(value)
  } 
  return false;
}

const AddNewProduct = ({ setPageAddProduct, addProductComplete }) => {
  const [imageFile, setImageFile] = useState(null);
  const [productName, setProductName] = useState("");
  const [serialNum, setSerialNum] = useState("");
  const [packageType, setPackageType] = useState("Bottled");
  const [costPer, setCostPer] = useState("");
  const [arrayCategories, setArrayCategories] = useState([]);
  const [validDescription, setValidDescription] = useState(false);
  const [validName, setValidName] = useState(false);
  const [validCost, setValidCost] = useState(false);
  const [validQuantity, setValidQuantity] = useState(false);
  const [validPoints, setValidPoints] = useState(false);
  const [isAvailableForSale, setIsAvailableForSale] = useState(true);
  const [sale, setSale] = useState(false);
  const dispatch = useDispatch();
  const User = useSelector((state) => state.profile.userProfiles);
  const [packSize, setPackSize] = useState("16 oz");
  const [description, setDescription] = useState("");
  const [quantityAvailable, setQuantityAvailable] = useState("");
  const [pointsCost, setPointsCost] = useState("");
  const [changeActive, setChangeActive] = useState(true);
  // const categoriesResponse = useSelector(
  //   (state) => state.product.responseCategories
  // );
  const isFetchError = useSelector((state) => state.product.isFetchError);
  const isFetchSuccess = useSelector((state) => state.product.isFetchSuccess);
  const [successfully, setSuccessfully] = useState(false);
  const [newImageDisabled, setNewImageDisabled] = useState(true);

  const statusSale = (e) => setSale(e.target.value);

  const changeProduct = (e) => setProductName(e.target.value);

  useEffect(() => {
    let regex = /^[a-zA-Z][^0-9]{1,28}$/;
    const result = regex.test(productName);
    if (result === true && productName.length !== 0) {
      setValidName(false);
    } else setValidName(true);
    if (productName.length === 0) {
      setValidName(false);
    }
  }, [productName]);

  const changeSerialNum = (e) => setSerialNum(e.target.value);

  const changePackageType = (e) => setPackageType(e.target.value);

  const changeCostPer = (e) => {
    setCostPer(e.target.value);
    const error = validateNumString(e.target.value);
    if (error !== validCost) {
      setValidCost(error);
    }
  };

  const changePackSize = (e) => {
    setPackSize(e.target.value);
  };

  const changeDescription = (e) => {
    setDescription(e.target.value);
    if (description.length > 100) {
      setValidDescription(true);
    } else setValidDescription(false);
  };

  const changeQuantityAvailable = (e) => {
    setQuantityAvailable(e.target.value);
    const error = validateNumString(e.target.value);
    if (error !== validQuantity) {
      setValidQuantity(error);
    }
    setIsAvailableForSale(!error && Number(e.target.value) !== 0);
  };

  const changePointsCost = (e) => {
    setPointsCost(e.target.value);
    const error = validateNumString(e.target.value);
    if (error !== validPoints) {
      setValidPoints(error);
    }
  }

  const back = () => {
    setDisabled(true);
    if (
      productName.length > 0 ||
      serialNum.length > 0 ||
      description.length > 0 ||
      quantityAvailable.length > 0 ||
      costPer.length > 0 ||
      packageType !== "Bottled" ||
      packSize !== "16 oz"
    ) {
      setOpenModalQuestion(true);
    } else setPageAddProduct(false);
  };

  const textFieldLeft = [
    { name: "Product name", changeValue: changeProduct, value: productName },
    { name: "Serial number", changeValue: changeSerialNum, value: serialNum },
    { name: "Cost per item", changeValue: changeCostPer, value: costPer },
    {
      name: "Quantity available",
      changeValue: changeQuantityAvailable,
      value: quantityAvailable,
    },
  ];

  const textFieldRight = [
    { name: "Package size", changeValue: changePackSize, value: packSize },
    { name: "Loyalty points cost", changeValue: changePointsCost, value: pointsCost },
    { name: "Description", changeValue: changeDescription, value: description },
  ];

  const addNewProduct = async (event) => {
    const data = {
      photo: imageFile,
      productName: productName,
      serialNumber: serialNum,
      packingType: packageType,
      price: Number(costPer),
      packingSize: packSize,
      description: description,
      quantity: Number(quantityAvailable),
      status: Boolean(!sale),
      categoryIds: arrayCategories.map((category) => category.id),
      loyaltyPointsCost: Number(pointsCost),
    };

    setChangeActive(true);

    try {
      await dispatch(createNewProducts(User.accessToken, serialize(data)));
      setSuccessfully(true);
      addProductComplete();
    } catch (error) {
      console.error(error);
      setSuccessfully(false);
    }
  };

  const [image64Valid, setImage64Valid] = useState(true);
  const onChangeImage = (e) => {
    const files = e.target.files;
    const file = files[0];

    let image = document.getElementById("output");
    image.src = URL.createObjectURL(e.target.files[0]);
    if (image !== undefined) {
      setNewImageDisabled(false);
    } else setNewImageDisabled(true);

    if (file.size > 5 * 1024 * 1024) {
      setImage64Valid(false);
      setImageFile(null);
    } else {
      setImage64Valid(true);
      setImageFile(file);
    }
  };

  useEffect(() => {
    dispatch(getCategories());
  }, []);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    borderRadius: "5px",
    boxShadow: 24,
    p: 4,
  };
  const [disabled, setDisabled] = useState(true);
  const [openModalQuestion, setOpenModalQuestion] = useState(false);
  const leave = () => {
    setPageAddProduct(false);
    setImageFile(null);
  };

  useEffect(() => {
    const result = !(
      arrayCategories.length &&
      productName.length &&
      costPer.length &&
      description.length &&
      pointsCost.length &&
      quantityAvailable.length &&
      imageFile &&
      !validCost &&
      !validName &&
      !validDescription &&
      !validQuantity &&
      !validPoints
    );
    if (result !== changeActive) {
      setChangeActive(result);
    }
  }, [
    pointsCost,
    productName,
    imageFile,
    costPer,
    serialNum,
    description,
    quantityAvailable,
    validCost,
    validName,
    validDescription,
    validQuantity,
    arrayCategories,
    validPoints
  ]);

  const stay = () => {
    setOpenModalQuestion(false);
    setDisabled(false);
  };

  const changeCategories = (nameCategories) => {
    let item = {
      id: nameCategories,
    };
    setArrayCategories((prev) => [...prev, item]);

    const names = arrayCategories.map((el) => el.id);

    let deleteItem = names.indexOf(nameCategories);
    if (deleteItem !== -1) {
      let newArray = arrayCategories.filter(
        (item) => item.id !== nameCategories
      );
      setArrayCategories(newArray);
    }
  };

  const getErrorPrefix = (validCost, validQuantity, validPoints) => {
    if (validCost) {
      return 'Cost per item:';
    }
    if (validQuantity) {
      return 'Quantity available:'
    }
    if (validPoints) {
      return 'Loyalty points cost:'
    }
  }

  return (
    <>
      {isFetchError && !successfully && (
        <Alert severity="error">
          Oops...Something went wrong! Reload the page.
        </Alert>
      )}
      {isFetchSuccess && successfully && (
        <Alert severity="success">
          The product has been successfully added.
        </Alert>
      )}
      <>
        <Modal open={openModalQuestion}>
          <Box sx={style}>
            <div>
              <p
                style={{ cursor: "pointer" }}
                className="exitModalAdd"
                onClick={stay}
              >
                x
              </p>
              <p
                style={{
                  fontFamily: "Open Sans",
                  textAlign: "center",
                  fontWeight: 700,
                }}
              >
                Unsaved progress will be lost
              </p>
              <p style={{ fontFamily: "Open Sans", textAlign: "center" }}>
                Leave the page?
              </p>
              <div
                style={{
                  fontFamily: "Open Sans",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-around",
                  fontWeight: 700,
                }}
              >
                <p onClick={() => stay()} style={{ cursor: "pointer" }}>
                  Stay
                </p>
                <p
                  onClick={() => leave()}
                  style={{ color: "red", cursor: "pointer" }}
                >
                  Leave
                </p>
              </div>
            </div>
          </Box>
        </Modal>
        <div className="header">
          <img onClick={() => back()} src={iconBack} alt="" />
          <p>Add new product</p>
        </div>
        <div className="body">
          <PhotoProduct
            setDisabled={setDisabled}
            disabled={disabled}
            onChangeImage={onChangeImage}
            title="Product Photo"
            state={newImageDisabled}
          />

          <div className="textField">
            <div>
              {textFieldLeft.map((item, index) => (
                <React.Fragment key={index}>
                  <TextField
                    changeValue={item.changeValue}
                    disabled={true}
                    styleInput={"inputEdit"}
                    labelStyle={"labelEdit"}
                    blockStyle={"inputLabelEdit"}
                    label={item.name}
                    value={item.value}
                    validate={item.validate}
                  />
                </React.Fragment>
              ))}
              <SelectTypeOption
                changePackageType={changePackageType}
                title={"addProduct"}
              />
            </div>

            <div className="rightBlock">
              <div style={{ marginTop: "11%", paddingLeft: "40px" }}>
                <MultiSelect changeCategories={changeCategories} />
              </div>

              {textFieldRight.map((item, index) => (
                <React.Fragment key={index}>
                  <TextField
                    changeValue={item.changeValue}
                    disabled={true}
                    styleInput={"inputEdit"}
                    labelStyle={"labelEdit"}
                    blockStyle={"inputLabelEdit"}
                    label={item.name}
                    value={item.value}
                  />
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>

        <div className="checkBox">
          <input
            type="checkbox"
            onChange={(e) => statusSale(e)}
            disabled={!isAvailableForSale}
            style={{
              opacity: isAvailableForSale ? 1 : 0.5,
              cursor: isAvailableForSale ? "pointer" : "not-allowed",
            }}
          />
          <p
            style={{
              opacity: isAvailableForSale ? 1 : 0.5,
            }}
          >
            Product is not available for sale
          </p>
        </div>

        <div className="validStyle">
          {validName ? (
            <p>
              Letters, spaces, apostrophes, and dashes are allowed or product
              name more than 30 symbols
            </p>
          ) : null}
          {validCost || validQuantity || validPoints ? <p>{getErrorPrefix(validCost, validQuantity, validPoints)} Only digits are allowed.</p> : null}
          {validDescription ? (
            <p>Description must be shorter than or equal to 100 characters</p>
          ) : null}
          {!image64Valid ? (
            <p style={{ color: "red" }}>
              Too big file size, image size should be less than 5MB
            </p>
          ) : null}
        </div>

        <div style={{ marginLeft: "290px" }}>
          <Button
            disabled={changeActive}
            typeAction={"profileButtonVisible"}
            typeNoActive={"profileActive"}
            type={changeActive ? "saveChangeProduct" : "saveChangeActiveProduct"}
            value={"Add new product"}
            click={addNewProduct}
          />
        </div>
      </>
    </>
  );
};
export default AddNewProduct;
